import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useAuth } from '../context/AuthContext';

const DebugScreen: React.FC = () => {
  const { isAuthenticated, isLoading, user } = useAuth();

  console.log('🐛 DebugScreen: isAuthenticated:', isAuthenticated, 'isLoading:', isLoading, 'user:', user);

  const testLogin = async () => {
    console.log('🧪 Testing manual login...');
    try {
      // This will be implemented shortly
    } catch (error) {
      console.error('Login test failed:', error);
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.content}>
        <Text style={styles.title}>🐛 Debug Screen</Text>
        
        <View style={styles.info}>
          <Text style={styles.label}>Loading: {String(isLoading)}</Text>
          <Text style={styles.label}>Authenticated: {String(isAuthenticated)}</Text>
          <Text style={styles.label}>User: {user ? user.name || user.email || 'Usuario sin nombre' : 'null'}</Text>
        </View>

        <TouchableOpacity style={styles.button} onPress={testLogin}>
          <Text style={styles.buttonText}>Test Login</Text>
        </TouchableOpacity>

        <Text style={styles.note}>
          Esta pantalla aparece cuando hay problemas con la autenticación.{'\n'}
          Revisa la consola para más detalles.
        </Text>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f8f9fa',
  },
  content: {
    flex: 1,
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#e74c3c',
    marginBottom: 30,
  },
  info: {
    backgroundColor: 'white',
    padding: 20,
    borderRadius: 8,
    marginBottom: 30,
    width: '100%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  label: {
    fontSize: 16,
    marginBottom: 10,
    color: '#2c3e50',
    fontFamily: 'monospace',
  },
  button: {
    backgroundColor: '#e74c3c',
    paddingHorizontal: 30,
    paddingVertical: 15,
    borderRadius: 8,
    marginBottom: 30,
  },
  buttonText: {
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
  },
  note: {
    fontSize: 14,
    color: '#7f8c8d',
    textAlign: 'center',
    lineHeight: 20,
  },
});

export default DebugScreen;
